  <div (click)="navigateToUserProfile(playerObj.user_profile.custom_id)" 
    class="player-container d-flex align-items-center cursor-pointer" 
    [ngClass]="{'first-winner' : ranking === 1, 'second-winner' : ranking === 2, 'third-winner' : ranking === 3, 'cursor-pointer':playerObj.user_profile.custom_id !== ''}"
    [appAnalyticsEvent]="analyticsProfileData">
    <span class="paragraph-bold player__rank d-flex align-items-center" *ngIf="!isTopScore">
      #{{ranking}} <img *ngIf="ranking < 4"
      [src]="(ranking === gameRank.RANK1)? 'assets/themes/icons/first-rank-img.svg'
      : (ranking === gameRank.RANK2) ? 'assets/themes/icons/second-rank-img.svg'
      : 'assets/themes/icons/third-rank-img.svg'" class="ml-1" alt="Crown icon" />
    </span>
    <div class="player__profile d-flex align-items-center"
      [ngClass]="{'flex-column text-center': columnCard > 2}">
      <span class="player__profile__image" 
        [ngClass]="{'excellent_players': isTopScore}">
        <img [src]="playerObj.user_profile.profile_pic" 
          onerror="this.src='assets/themes/icons/user-profile-placeholder.svg';" 
          alt="profile icon" />
        <span class="player__profile__score d-flex align-items-center justify-content-center" *ngIf="isTopScore">
          {{ranking}} <img
            [src]="(ranking === gameRank.RANK1)? 'assets/themes/icons/first-rank-img.svg'
            : (ranking === gameRank.RANK2) ? 'assets/themes/icons/second-rank-img.svg'
            : 'assets/themes/icons/third-rank-img.svg' " alt="Crown icon" />
        </span>
      </span>
      <div class="ml-2 mt-2" [ngClass]="{'lh-1': isTopScore}">
        <h5 class="heading-4">{{playerObj?.user_profile?.user_name}}</h5>
        <span *ngIf="isTopScore" class="secondary-paragraph color-grey-500">Score-{{playerObj.points}}</span>
        <span *ngIf="!isTopScore">
          <ng-container *ngIf="playerObj?.user_profile?.speciality.length > numbers.ZERO">
            <label *ngFor="let speObj of playerObj.user_profile.speciality" class="secondary-paragraph">
              <span class="color-grey-500">{{speObj?.speciality_name}}</span>
            </label>
          </ng-container>
        </span>
      </div>
    </div>
    <span class="heading-4" *ngIf="!isTopScore">
      {{playerObj.points}}
    </span>
  </div>